module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-regular.1dfb815c0e707ba03fb3486d94881ca4.woff2";